import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { api, handleError } from 'API'
import { IIconBuilder, IIconBuilderWithRelations } from 'interfaces/iconBuilder'

export async function createIcon(userData: IIconBuilder): Promise<IIconBuilderWithRelations> {
  try {
    const response = await api.post(`/icons`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/iconBuilder.ts', 'createIcon')
    return {}
  }
}

export async function countIcon(where: Where<IIconBuilder> = {}): Promise<number> {
  try {
    const { data = 0 } = await api.get(`/icons/count?where=${JSON.stringify(where)}`)
    return Number(get(data, 'count', 0))
  } catch (error: any) {
    handleError(error as Error, 'API/iconBuilder.ts', 'countIcon')
    return 0
  }
}

export async function getIcon(filter: IFilter<IIconBuilder>): Promise<IIconBuilderWithRelations[]> {
  try {
    const response = await api.get(`/icons?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/iconBuilder.ts', 'getIcon')
    return []
  }
}

export async function getIconDetail(id: string, filter: IFilter<IIconBuilder>): Promise<IIconBuilderWithRelations> {
  try {
    const response = await api.get(`/icons/${id}?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/iconBuilder.ts', 'getIconDetail')
    return {}
  }
}

export async function updateIcon(id: number, userData: IIconBuilder): Promise<IIconBuilder> {
  try {
    const response = await api.patch(`/icons/${id}`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/iconBuilder.ts', 'updateIcon')
    return {}
  }
}

export async function deleteIcon(id: number): Promise<void> {
  try {
    const response = await api.delete(`/icons/${id}`)
    return response.data
  } catch (error: any) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/iconBuilder.ts', 'deleteIcon')
    throw new Error(errorMessage)
  }
}

export async function deleteAndAssignDefaultIcon(id: number): Promise<void> {
  try {
    const response = await api.delete(`/icons/assign-default/${id}`)
    return response.data
  } catch (error: any) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/iconBuilder.ts', 'deleteAndAssignDefaultIcon')
    throw new Error(errorMessage)
  }
}
